<template>

    <div class="shop::website-modules-shopProducts-show-ProductVariantSelector mt-4">

        <div class="text-gray-700" v-if="showStock">
            <span
                v-if="productIsInStock && (selectedAttributeValuesVariantExists('is_in_stock') || selectedAttributeValuesEqualsInitial())"
                class="flex items-center gap-2 my-4"
            >
                <span class="w-3 h-3 bg-green-400 rounded-full"></span> In voorraad
            </span>
            <span
                v-else-if="productIsInStock && selectedAttributeValuesEqualsInitial(false)"
                class="flex items-center gap-2 my-4"
            >
                <span class="w-3 h-3 bg-red-400 rounded-full"></span> Niet beschikbaar
            </span>
            <span v-else class="flex items-center gap-2 my-4">
                <span class="w-3 h-3 bg-red-400 rounded-full"></span> Niet in voorraad
            </span>
        </div>

        <div v-for="(shopProductAttribute, shopProductAttributeNumber) in shopProductAttributes"
             class="flex flex-wrap items-baseline mb-6"
        >

            <div class="w-full text-sm font-bold mb-3">
                {{ shopProductAttribute.name[language] }}
            </div>

            <div class="w-full md:w-1/2" v-if="shopProductAttribute.attribute.type === 'select'">
                <select class="w-full rounded border-gray-400" v-model="selectedAttributeValues[shopProductAttribute.id]">
                    <option v-for="attributeValue in shopProductAttribute.attributeValues"
                        :value="attributeValue"
                    >
                        {{ attributeValue }}
                    </option>
                </select>
            </div>

            <div class="w-full flex flex-wrap gap-3" v-else>

                <label v-for="attributeValue in shopProductAttribute.attributeValues"
                       :class="{
                            'cursor-pointer': productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) !== -1,
                        }"
                       :title="productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1
                            ? 'Deze variant is niet beschikbaar met de huidige selectie'
                            : ''
                        "
                       :dusk="(shopProductAttribute.name[language].replace(' ', '_') + '-' + attributeValue.replace(' ', '_')).toLowerCase()"
                       x-data="{
                            labelOpen: false
                       }"
                >

                    <input type="radio"
                           class="sr-only"
                           v-model="selectedAttributeValues[shopProductAttribute.id]"
                           :name="selectedAttributeValues[shopProductAttribute.id]"
                           :value="attributeValue"
                    >

                    <span class="flex relative" v-if="attributeValue.includes('[color=')"
                          x-on:mouseover="labelOpen = true"
                          x-on:mouseleave="labelOpen = false"
                    >
                        <span class="inline-flex overflow-hidden rounded-full h-8 w-8">
                            <span class="w-full" v-for="color in attributeValue.replace('[color=', '').replace(']', '').split('|')"
                                  :style="'background-color: ' + color"
                            ></span>
                        </span>

                        <span class="-mt-2 -translate-x-1/2 -translate-y-full absolute bg-white flex flex-col gap-2 items-center left-1/2 px-4 py-2 rounded shadow top-0 transform pointer-events-none z-40"
                              x-show="labelOpen"
                        >
                            <span class="inline-flex overflow-hidden rounded h-12 w-12">
                                <span class="w-full" v-for="color in attributeValue.replace('[color=', '').replace(']', '').split('|')"
                                      :style="'background-color: ' + color"
                                ></span>
                            </span>

                            <span class="text-sm">
                                {{ findProductAttributeLabelFromValue(shopProductAttributeNumber, attributeValue) }}
                            </span>

                            <span class="-bottom-6 -translate-x-1/2 absolute left-1/2 mb-1 text-3xl text-white transform">
                                <i class="fas fa-caret-down"></i>
                            </span>
                        </span>

                        <span class="-bottom-2 -mr-2 absolute bg-red-500 text-white block h-5 items-center justify-center pointer-events-none right-0 rounded-full shadow w-5 z-10"
                            :class="{
                                'inline-flex': selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesEqualsInitial(false)
                                    && !selectedAttributeValuesVariantExists(),
                                'hidden': !(selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesEqualsInitial(false)
                                    && !selectedAttributeValuesVariantExists()
                                )
                            }"
                        >
                            <i class="fas fa-times"></i>
                        </span>

                        <span class="border-gray-500 absolute inset-0 -m-[5px] pointer-events-none rounded-full"
                              :class="{
                                'border': selectedAttributeValues[shopProductAttribute.id] === attributeValue,
                            }"
                        ></span>
                    </span>
                    <span v-else
                          class="border border-gray-400 min-w-[6rem] rounded-3xl p-3 mb-0 flex items-center justify-center text-sm font-medium focus:outline-none"
                          :class="{
                            'bg-white text-black border-black hover:bg-gray-100': (selectedAttributeValues[shopProductAttribute.id] !== attributeValue),
                            'bg-palette-orange border-palette-orange text-white':
                                (
                                    selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesVariantExists()
                                    && selectedAttributeValuesEqualsInitial(false)
                                ) || (
                                    initialSelectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesEqualsInitial()
                                ),
                            'bg-gray-400 text-white border-gray-400': selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                && selectedAttributeValuesEqualsInitial(false),
                            // || (
                            //     selectedAttributeValues[shopProductAttribute.id] === attributeValue &&
                            //     initialSelectedAttributeValues[shopProductAttribute.id] !== selectedAttributeValues[shopProductAttribute.id]
                            // ),
                        }">
                      {{ attributeValue }}
                    </span>

                </label>

            </div>

        </div>

        <div class="mt-8 flex sm:flex-col1" v-if="productIsInStock">

            <div
                class="relative numberInput bg-white flex mr-6 font-normal px-4 py-1 rounded-3xl text-center w-36"
            >
                <div v-if="showMinimumOrderQuantityMessage"
                    class="-mt-2 -translate-x-1/2 -translate-y-full absolute bg-white left-1/2 px-4 py-2 rounded-xl top-0 w-40"
                >
                    <span v-text="'Het minimum aantal is ' + minimumOrderQuantity"></span>
                </div>

                <button
                    class="flex-shrink-0 focus:ring-1 focus:ring-offset-2 mr-2 my-auto w-6 h-6 rounded-full minus"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    @click="checkOrderQuantity(false)"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                >
                    <i class="fal fa-minus"></i>
                </button>
                <input
                    class="appearance-none bg-transparent border-none flex-1 text-center w-full"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    type="number"
                    name="amount"
                    dusk="amount"
                    v-model="amount"
                    :min="minimumOrderQuantity"
                    @change="checkOrderQuantity()"
                    placeholder="Aantal"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                />
                <button
                    class="flex-shrink-0 focus:ring-1 focus:ring-offset-2 ml-2 my-auto plus w-6 h-6 rounded-full"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    @click="checkOrderQuantity(true)"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                >
                    <i class="fal fa-plus"></i>
                </button>
            </div>

            <button
                name="addToCart"
                dusk="add_to_cart"
                class="max-w-xs flex-1 rounded-3xl py-3 px-8 flex items-center justify-center text-sm text-white focus:outline-none"
                :class="{
                    'bg-gray-400': !selectedAttributeValuesVariantExists('is_in_stock')
                        && selectedAttributeValuesEqualsInitial(false),
                    'opacity-75': selectedAttributeValuesVariantExists('is_in_stock')
                        && selectedAttributeValuesEqualsInitial(false),
                    'bg-green-500 hover:bg-green-600': selectedAttributeValuesVariantExists('is_in_stock')
                        || selectedAttributeValuesEqualsInitial(),
                }"
                :disabled="!selectedAttributeValuesVariantExists('is_in_stock') || selectedAttributeValuesEqualsInitial(false)"
            >
                <div class="shop::website-modules-shopProducts-Checkmark">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>

                <span class="failedIcon absolute hidden text-lg"><i class="fas fa-times"></i></span>

                <span class="md:inline hidden">
                   In winkelwagen
                </span>

                <span class="absolute left-1/2 transform -translate-x-1/2 clickLoad hidden">
                    <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </span>

                <span class="inline md:hidden">
                    <img src="/img/website/cart-white.svg" alt="winkelwagen">
                </span>
            </button>

        </div>

    </div>

</template>

<style lang="scss" scoped>

.shop\:\:website-modules-shopProducts-show-ProductVariantSelector {
    .not-available {
        background: linear-gradient(to bottom right, transparent, transparent 49%, #a3a3a3 51%, transparent 52%, transparent);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<script>

// TODO Medium: Support product variants which are missing a product attribute (in comparison to others), by adding a 'fake' "Geen" attribute value?
export default {

    props: {
        productVariants: String, // Object
        currentProductVariantId: {
            type: Number,
            required: true,
        },
        productVariantBaseUrl: {
            type: String,
            required: true,
        },
        minimumOrderQuantity: Number,
        productIsInStock: Boolean,
        showStock: Boolean,
        language: String,

        discountSlug: String,
        discountPercentage: Number,
    },

    data() {
        return {
            productVariantsLocal: JSON.parse(this.$options.propsData.productVariants),
            initialSelectedAttributeValues: {},
            selectedAttributeValues: {},

            amount: this.minimumOrderQuantity,
            showMinimumOrderQuantityMessage: false,
        };
    },

    mounted() {
        this.initSelectedAttributeValues('initialSelectedAttributeValues');
        this.initSelectedAttributeValues('selectedAttributeValues');
    },

    methods: {

        checkOrderQuantity(addOrRemove = null)
        {
            let amount = this.amount;

            if( addOrRemove !== null) {
                amount = amount + (addOrRemove === true ? 1 : -1);
            }

            // Check quantity is less than minimum
            this.showMinimumOrderQuantityMessage = amount < this.minimumOrderQuantity;

            if( this.showMinimumOrderQuantityMessage ) {
                this.amount = this.minimumOrderQuantity;
            } else {
                this.amount = amount;
            }
        },

        findProductAttributeLabelFromValue(shopProductAttributeNumber, attributeValue)
        {
            let shopProductAttribute = this.shopProductAttributes[shopProductAttributeNumber],
                shopProductAttributeValueIndex = shopProductAttribute.attributeValues.findIndex((shopProductAttributeValue) => shopProductAttributeValue === attributeValue);

            return shopProductAttribute.attributeLabels[shopProductAttributeValueIndex]
        },

        selectedAttributeValuesEqualsInitial(doesEqual = true) {
            if (!doesEqual) {
                return JSON.stringify(this.initialSelectedAttributeValues) !== JSON.stringify(this.selectedAttributeValues);
            }

            return JSON.stringify(this.initialSelectedAttributeValues) === JSON.stringify(this.selectedAttributeValues);
        },

        // When the user has a new variant selection, we then check if this selection is indeed a valid variant selection
        // so that we can show to the user that the selection is valid with some styling
        selectedAttributeValuesVariantExists(property = null) {
            let variant = this.productVariantsLocal.filter(variant => variant.shop_product_variant_attributes
                .map(variantAttribute => Object.values(this.selectedAttributeValues).includes(variantAttribute.value))
                .every(value => value)
            );

            if (property) {
                return variant.length ? variant[0]?.[property] : null;
            }

            return variant.length;
        },

        initSelectedAttributeValues(selectValueString) {
            // Get product variant.
            let productVariant = _.find(this.productVariantsLocal, {id: this.currentProductVariantId});

            // Loop product attributes.
            for (let shopProductAttribute of this.shopProductAttributes) {
                // Get variant attribute.
                let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, {shop_product_attribute_id: shopProductAttribute.id});

                // TODO Low: Fix empty productVariantAttribute when this product variant is missing this attribute.
                // Set value of variant attribute as selected value?
                if (productVariantAttribute)
                    this.$set(this[selectValueString], shopProductAttribute.id, productVariantAttribute.value);
            }
        },

        filterProductVariants(skipShopProductAttribute = null) {
            // Get all product variants.
            let productVariants = [].concat(this.productVariantsLocal);

            // Filter on selection, but not the given product attribute.
            for (let [id, attributeValue] of Object.entries(this.selectedAttributeValues)) {
                // Skip due to has no filter or is given product attribute?
                if (attributeValue === null || attributeValue === '' || (skipShopProductAttribute && skipShopProductAttribute.id == id))
                    continue;

                // Filter out selection.
                productVariants = _.filter(productVariants, productVariant => {
                    let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == id);

                    return productVariantAttribute && productVariantAttribute.value === attributeValue;
                });
            }

            //
            return productVariants;
        },

        // TODO Low: Refactor to computed property so we can loose the $forceUpdate in the <select.
        // TODO Low: Optimize, refactor.
        productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute) {
            // Get all product variants.
            let productVariants = this.filterProductVariants(shopProductAttribute);

            // No product variants left?
            if (productVariants.length == 0)
                return false;

            // Filter on the given value.
            productVariants = _.filter(productVariants, productVariant => {
                let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == shopProductAttribute.id);

                return productVariantAttribute && productVariantAttribute.value === attributeValue;
            });

            // Has product variants left?
            return productVariants.length > 0;
        },

        manageUrl() {
            // Abort due to no product variant selected?
            if (!this.selectedProductVariant)
                return;

            // Construct new url.
            let newUrl = this.productVariantBaseUrl.replace(':shopProductVariantSlug', this.selectedProductVariant.slug['nl']);
            let queryParts = [];

            // Add filtered store?
            if (this.storeId)
                queryParts.push('store=' + this.storeId);

            // Add filtered discount?
            if (this.discountSlug)
                queryParts.push('actie=' + this.discountSlug);

            // Add url query parts?
            if (queryParts.length > 0)
                newUrl += (!newUrl.includes('?') ? '?' : '') + queryParts.join('&');

            // Navigate due to new url?
            if (newUrl != document.location.href) {
                document.location.href = newUrl;
            }
        }

    },

    watch: {

        'selectedProductVariant'(newVal) {
            // Navigate to new product variant?
            if (newVal) {
                this.manageUrl();

                // @ugly this is ugly but because price is not in this component we have to hide it if attributes are unavailable
                $('.possiblePrices').removeClass('hidden');
            } else {
                // @ugly this is ugly but because price is not in this component we have to hide it if attributes are unavailable
                $('.possiblePrices').addClass('hidden');
            }
        },

    },

    computed: {

        shopProductAttributes() {
            let attributeId2attribute = {};

            // Loop product variants.
            for (let productVariant of this.productVariantsLocal) {
                for (let productVariantAttribute of productVariant.shop_product_variant_attributes) {

                    // Get or make existing item.
                    let existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id];

                    if (!existingItem)
                        existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id] = {
                            attributeValues: [],
                            attributeLabels: [],
                            ...productVariantAttribute.shop_product_attribute,
                            attribute: productVariantAttribute.shop_product_attribute?.shop_attribute || {}
                        };

                    // Skip due to value already seen?
                    if (existingItem.attributeValues.indexOf(productVariantAttribute.value) !== -1)
                        continue;

                    // Add attribute value.
                    existingItem.attributeLabels.push(productVariantAttribute.label);
                    existingItem.attributeValues.push(productVariantAttribute.value);
                }
            }

            // Sort by attribute sequence.
            return _.sortBy(
                Object.values(attributeId2attribute),
                'sequence'
            );
        },

        //productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1

        productVariantExistsForAttributeValue() {
            let result = {};

            // Loop product attributes.
            for (let shopProductAttribute of this.shopProductAttributes) {
                let attributeValuesExists = [];

                // Loop values.
                for (let attributeValue of shopProductAttribute.attributeValues) {
                    if (this.productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute))
                        attributeValuesExists.push(attributeValue);
                }

                // Set
                result[shopProductAttribute.id] = attributeValuesExists;
            }

            //
            return result;
        },

        selectedProductVariant() {
            // Get filtered product variants.
            let productVariants = this.filterProductVariants();

            // Return only the one and only one.
            return productVariants.length == 1 ? productVariants[0] : null;
        },

    },

}

</script>
